"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const epic_alt_utils_1 = require("epic-alt-utils");
/**
 * @returns {React.Component}
 */
function registerErrorMessage(configStore, getLocale, Message) {
    let ErrorMessage = class ErrorMessage extends react_1.default.Component {
        static getStores() {
            return [configStore];
        }
        static getPropsFromStores() {
            return {
                config: configStore.getState().config
            };
        }
        renderMessage() {
            const { msg, args, className } = this.props;
            return react_1.default.createElement(Message, { code: msg, args: args, className: className });
        }
        renderCode(codeStr, link) {
            const { code } = this.props;
            if (!codeStr || !code)
                return null;
            const finalCode = codeStr.replace('{code}', code);
            if (code) {
                return link ? (react_1.default.createElement("a", { className: "error-code", href: link.replace('{code}', code) }, finalCode)) : (react_1.default.createElement("span", { className: "error-code" }, finalCode));
            }
            return null;
        }
        render() {
            const { config: { errorMessageFormat, errorMessageCodeLink } } = this.props;
            const locale = getLocale();
            let formatStr = errorMessageFormat
                ? errorMessageFormat[locale] || errorMessageFormat['en-US']
                : null;
            formatStr = formatStr || '{msg};Error code: {code}';
            const formatArray = formatStr.split(';');
            if (formatArray[0].indexOf('{msg}') !== -1) {
                return (react_1.default.createElement("span", null,
                    this.renderMessage(formatArray[0]),
                    this.renderCode(formatArray[1], errorMessageCodeLink)));
            }
            return (react_1.default.createElement("span", null,
                this.renderCode(formatArray[0], errorMessageCodeLink),
                this.renderMessage(formatArray[1])));
        }
    };
    ErrorMessage.propTypes = {
        className: prop_types_1.default.string,
        msg: prop_types_1.default.string,
        args: prop_types_1.default.array,
        code: prop_types_1.default.string,
        config: prop_types_1.default.object
    };
    ErrorMessage = __decorate([
        epic_alt_utils_1.connectToStores
    ], ErrorMessage);
    return ErrorMessage;
}
exports.default = registerErrorMessage;
//# sourceMappingURL=ErrorMessage.js.map